import { render, staticRenderFns } from "./Signatures.vue?vue&type=template&id=ab1f2662&scoped=true"
import script from "./Signatures.vue?vue&type=script&lang=js"
export * from "./Signatures.vue?vue&type=script&lang=js"
import style0 from "./Signatures.vue?vue&type=style&index=0&id=ab1f2662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1f2662",
  null
  
)

export default component.exports